import React from "react";
import GungorenSidebar from "../Sidebar/GungorenSidebar";
import GungorenOtherServices from "../ServiceAreas/GungorenServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const GungorenIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        GÜNGÖREN HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Yoğun şehir yaşamının etkisiyle halılar ve koltuklar zamanla kirlenir,
            toz, leke ve mikroorganizmalara maruz kalır. Güingören Halı Yıkama hizmetimiz,
            tüm bu sorunlara profesyonel çözümler sunar. Modern ekipman ve özel yıkama teknikleriyle,
            hem hijyenik hem de uzun ömürlü temizlik sağlıyoruz.
          </p>

          <p>
            Halılarınız uygun yıkama programlarıyla zarar görmeden yıkanır,
            koltuklarınız özel buharlı sistemlerle derinlemesine temizlenir.
            Alerjenlerden arınır, ev ortamı daha sağlıklı hale gelir.
          </p>

          <p>
            <strong>Hizmetlerimizin öne çıkan özellikleri:</strong>
          </p>

          <ul className="list-disc list-inside">
            <li>Ücretsiz Alım ve Teslim: Güngören’in tüm mahallelerinden kapıdan alım
              ve zamanında teslimat
            </li>
            <li>Organik ve cilt dostu temizlik ürünleri</li>
            <li>Derinlemesine koltuk yıkama ve leke çıkartma</li>
            <li>Yorgan, battaniye ve perde yıkama hizmetleri</li>
            <li>Yerinde koltuk yıkama seçeneği</li>
            <li>48 saat içinde teslim garantisi</li>
          </ul>

          <p>
            Güngören genelinde; Merter, Tozkoparan, Sanayi Mahallesi ve Haznedar
            gibi bölgelerde aktif olarak hizmet vermekteyiz. Mobil servis aracılığıyla
            çok kısa sürede kapınızdan teslim alım yapılır.
          </p>

          <p>
            Tüm halılarınız önce toz alma makinelerinde detaylı bir şekilde
            tozdan arındırılır, sonra tam otomatik yıkama makinelerinde yıkanır
            ve paketlenerek geri teslim edilir.
          </p>

          <p>
            Bizimle iletişime geçerek hizmet taleplerinizi kolayca iletebilir,
            fiyat bilgisi ve kampanyalarımız hakkında detaylı bilgi alabilirsiniz.
          </p>

          {/* Mahalle sidebar ve hizmet bölgeleri */}
          <GungorenSidebar />
          <GungorenOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default GungorenIntro;
